//src/services/medicineNewService.js
import apiClient from "./apiClient";
import axios from "axios";
import {
  formatMedicineCatalogFields,
  normalizeMedicineItem,
  normalizeMedicineList,
} from "../utils/nameFormatUtils";

const API_URL = `/medicines`; // Use relative path since apiClient has baseURL

// Helper function to get environment variable
const getEnvVar = (key, defaultValue = null) => {
  if (typeof window !== 'undefined' && window.env && typeof window.env === 'object' && window.env[key]) {
    return window.env[key];
  }
  if (process.env && process.env[key]) {
    return process.env[key];
  }
  return defaultValue;
};

const BACKEND_URL = getEnvVar('REACT_APP_BACKEND_URL', 'http://localhost:8080/api');
  
export const createNewMedicine = async (reqData) => {
  try {
    // Create medicine in base raw medicine table (not organization-specific)
    // Use direct axios call to bypass apiClient's organizationId interceptor
    console.log(`[createNewMedicine] Creating medicine in base raw medicine table...`);
    
    const token = localStorage.getItem("token");
    const apiUrl = `${BACKEND_URL}${API_URL}`;
    
    const response = await axios.post(apiUrl, formatMedicineCatalogFields(reqData), {
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
    
    console.log(`[createNewMedicine] ✅ Successfully created medicine in base table`);
    return normalizeMedicineItem(response.data);
  } catch (error) {
    console.error("[createNewMedicine] ❌ Error creating medicine:", error);
    throw error;
  }
};

export const getAllMedicine = async () => {
  try {
    // Fetch from base raw medicine table (not organization-specific)
    // Use direct axios call to bypass apiClient's organizationId interceptor
    console.log(`[getAllMedicine] Fetching medicines from base raw medicine table...`);
    
    const token = localStorage.getItem("token");
    const apiUrl = `${BACKEND_URL}${API_URL}`;
    
    const response = await axios.get(apiUrl, {
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
    
    const data = response.data;
    console.log(`[getAllMedicine] ✅ Fetched ${Array.isArray(data) ? data.length : 0} medicines from base table`);
    return normalizeMedicineList(data);
  } catch (error) {
    console.error("[getAllMedicine] ❌ Error fetching medicine:", error);
    throw error;
  }
};

// Update function to use PUT method
export const updateMedicine = async (reqData) => {
  try {
    // Update medicine in base raw medicine table (not organization-specific)
    // Use direct axios call to bypass apiClient's organizationId interceptor
    console.log(`[updateMedicine] Updating medicine ID ${reqData.id} in base raw medicine table...`);
    
    const token = localStorage.getItem("token");
    const apiUrl = `${BACKEND_URL}${API_URL}/${reqData.id}`;
    
    const response = await axios.put(apiUrl, formatMedicineCatalogFields(reqData), {
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
    
    console.log(`[updateMedicine] ✅ Successfully updated medicine ID ${reqData.id} in base table`);
    return normalizeMedicineItem(response.data);
  } catch (error) {
    console.error(`[updateMedicine] ❌ Error updating medicine ID ${reqData.id}:`, error);
    throw error;
  }
};

export const deleteMedicine = async () => {
  try {
    // apiClient will automatically add organizationId as query param via interceptor
    const response = await apiClient.get(API_URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching medicine:", error);
    throw error;
  }
};

//fetch by name
export const getCostPerUnit = async (medicineName) => {
  try {
    // apiClient will automatically add organizationId as query param via interceptor
    const response = await apiClient.get(`${API_URL}/cost/${medicineName}`);
    return parseFloat(response.data); // Convert to float
  } catch (error) {
    console.error("Error fetching cost per unit:", error);
    throw error;
  }
};

//fetch by id
export const getCostPerUnitById = async (medicineId) => {
  try {
    // Fetch from basic medicine table (not organization-specific)
    // Since medicine inventory table has medicine_id from basic medicine raw table,
    // we need to fetch cost from the basic table
    console.log(`[getCostPerUnitById] Fetching cost for medicine ID ${medicineId} from basic table...`);
    
    const apiUrl = `${BACKEND_URL}${API_URL}/cost/id/${medicineId}`;
    
    // Get authentication token
    const token = localStorage.getItem("token");
    
    // Use axios directly to fetch from base table (without organizationId)
    // This ensures we fetch from the basic medicine table, not organization-specific table
    const response = await axios.get(apiUrl, {
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
    
    const costPerUnit = parseFloat(response.data);
    console.log(`[getCostPerUnitById] ✅ Fetched cost per unit: ${costPerUnit} for medicine ID ${medicineId}`);
    return costPerUnit; // Convert to float
  } catch (error) {
    console.error(`[getCostPerUnitById] ❌ Error fetching cost per unit for medicine ID ${medicineId}:`, error);
    throw error;
  }
};